﻿import React, { useEffect, useState } from 'react';

import { Button, CompositeView, GridView, SimpleView, Widget } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { hasPermission } from '@app/helpers/permissions';

import {
  Clausula,
  enviarTodosParaAprovacaoNivel1ou2,
  getAllClausulaComItemNivel1,
  getAllClausulaComItemNivel2,
} from '../../../api/minuta/Clausula';
import TabelaItemParaAprovacao from './TabelaItemParaAprovacao';
import TabelaItemParaAprovacaoNivel2 from './TabelaItemParaAprovacaoNivel2';

const AprovacaoDeItens = () => {
  const { Panel } = Collapse;

  const [clausulaResult, setClausulaResult] = useState<Clausula[]>([]);
  const [clausulaNivel2Result, setClausulaNivel2Result] = useState<Clausula[]>([]);
  const [getList, setGetList] = useState<boolean>(true);

  const loadAllClausulasNivel1 = () => {
    getAllClausulaComItemNivel1().then(data => {
      if (data) {
        const result = data.filter(obj => {
          return obj.itens.length > 0;
        });
        if (result) {
          setClausulaResult(result);
        }
      }
    });
  };

  const loadAllClausulasNivel2 = () => {
    getAllClausulaComItemNivel2().then(data => {
      if (data) {
        const result = data.filter(obj => {
          return obj.itens.length > 0;
        });
        if (result) {
          setClausulaNivel2Result(result);
        }
      }
    });
  };

  const enviarTodosParaAprovacao = (fluxo: string, id: string) => {
    enviarTodosParaAprovacaoNivel1ou2(fluxo, id).then((data: any) => {
      if (fluxo == 'ADM') {
        loadAllClausulasNivel1();
        loadAllClausulasNivel2();
      } else loadAllClausulasNivel2();
    });
  };

  useEffect(() => {
    loadAllClausulasNivel1();
    loadAllClausulasNivel2();
  }, [getList]);

  return (
    hasPermission(['APROVADOR_CLAUSULA_NIVEL_2', 'APROVADOR_CLAUSULA_NIVEL_1']) && (
      <SimpleView>
        <CompositeView>
          {hasPermission(['APROVADOR_CLAUSULA_NIVEL_1']) ? (
            <GridView icon="commons-info" noform id="itensPendentesDeAprovacaoDeNivel1" title="APROVAÇÃO ADM CONTRATOS">
              {clausulaResult && clausulaResult.length > 0 ? (
                <>
                  {clausulaResult.map((clausula: any) => {
                    return (
                      <>
                        <Collapse
                          key={`${clausula.id}`}
                          bordered={false}
                          expandIcon={() => <Icon type="arrows-right_4" />}>
                          <Panel key={`${clausula.id}`} header={`${clausula.descricao}`}>
                            {clausula.tipoClausula}
                            <Widget
                              actions={[
                                <Button
                                  type="primary"
                                  icon="messaging-send"
                                  onClick={() => enviarTodosParaAprovacao('ADM', clausula.id)}>
                                  APROVAR TODOS
                                </Button>,
                              ]}>
                              <TabelaItemParaAprovacao
                                clausulaResult={clausula}
                                getAllClausula={getAllClausulaComItemNivel1}
                                setGetList={setGetList}
                                getList={getList}
                              />
                            </Widget>
                          </Panel>
                        </Collapse>
                      </>
                    );
                  })}
                </>
              ) : (
                <></>
              )}
            </GridView>
          ) : (
            () => {}
          )}
          {hasPermission(['APROVADOR_CLAUSULA_NIVEL_2']) ? (
            <GridView icon="commons-info" noform id="itensPendentesDeAprovacaoDeNivel2" title="APROVAÇÃO GERENTE">
              {clausulaNivel2Result && clausulaNivel2Result.length > 0 ? (
                <>
                  {clausulaNivel2Result.map(clausula => {
                    return (
                      <>
                        <Collapse
                          key={`${clausula.id}`}
                          bordered={false}
                          expandIcon={() => <Icon type="arrows-right_4" />}>
                          <Panel key={`${clausula.id}`} header={`${clausula.descricao}`}>
                            {clausula.tipoClausula}
                            <Widget
                              actions={[
                                <Button
                                  type="primary"
                                  icon="messaging-send"
                                  onClick={() => enviarTodosParaAprovacao('JURIDICO', clausula.id)}>
                                  APROVAR TODOS
                                </Button>,
                              ]}>
                              <TabelaItemParaAprovacaoNivel2
                                clausulaResult={clausula}
                                getAllClausula={getAllClausulaComItemNivel2}
                                setGetList={setGetList}
                                getList={getList}
                              />
                            </Widget>
                          </Panel>
                        </Collapse>
                      </>
                    );
                  })}
                </>
              ) : (
                <></>
              )}
            </GridView>
          ) : (
            () => {}
          )}
        </CompositeView>
      </SimpleView>
    )
  );
};

export default AprovacaoDeItens;
